import { EProgramType } from '../../../../types/mortgage/programType';
import baseIcon from './base.svg';
import countryIcon from './country.svg';
import familyIcon from './family.svg';
import farIcon from './far.svg';
import itIcon from './it.svg';
import preferentialIcon from './preferential.svg';

export const programIcons: Record<EProgramType, string> = {
  [EProgramType.BASE]: baseIcon,
  [EProgramType.COUNTRY]: countryIcon,
  [EProgramType.FAMILY]: familyIcon,
  [EProgramType.FAR]: farIcon,
  [EProgramType.IT]: itIcon,
  [EProgramType.PREFERENTIAL]: preferentialIcon,
};
